<template>
  <vca-card class="shadowed">
    <vca-row>
      <h2>{{ $t("users.popup.applications") }}</h2>
    </vca-row>
    <vca-row>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th class="vca-table-cell">{{ $t("events.dates.label") }}</th>
              <th class="vca-table-cell">
                <label> {{ $t("table.header.type") }}</label>
              </th>
              <th class="vca-table-cell">
                <label> {{ $t("events.label") }}</label>
              </th>
              <th class="vca-table-cell">
                <label> {{ $t("events.location.label") }}</label>
              </th>
              <th class="vca-table-cell">
                <label> {{ $t("events.crew.label") }}</label>
              </th>
              <th class="vca-table-cell">
                <label>{{ $t("events.participations.status.header") }}</label>
              </th>
              <th class="vca-table-cell"></th>
              <th class="vca-table-cell">
                <label>{{ $t("users.popup.application_time") }}</label>
              </th>
            </tr>
          </thead>
          <tr
            class="vca-table-row"
            v-for="(res, index) in userApplications()"
            :key="index"
          >
            <td class="vca-table-cell">
              {{ timePeriod(res.event.start_at, res.event.end_at) }}
            </td>
            <td class="vca-table-cell">{{ translateType(res.event) }}</td>
            <td class="vca-table-cell">
              <a :href="eventLink(res.event.id)" target="event">{{
                res.event.name
              }}</a>
            </td>
            <td class="vca-table-cell">
              {{ res.event.location.name }}, {{ res.event.location.city }}
            </td>
            <td class="vca-table-cell">
              {{ res.crew.name }}
            </td>
            <td class="vca-table-cell">
              {{ state(res) }}
            </td>
            <td class="vca-table-cell">
              <div v-if="res.comment" class="inline-infobox">
                <vca-info-box>{{ res.comment }}</vca-info-box>
              </div>
            </td>
            <td class="vca-table-cell">
              <small>
                {{ datetime(res.modified.created) }}<br />
                {{
                  timePeriod(
                    res.event.application.start_date,
                    res.event.application.end_date
                  )
                }}
              </small>
            </td>
          </tr>
        </table>
      </div>
    </vca-row>
  </vca-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProfileParticipants",
  data() {
    return {
      user_participations: [],
    };
  },
  created() {
    let data = { user_id: this.current.id };
    this.$store
      .dispatch({ type: "events/participations/queryList", data: data })
      .then((response) => {
        function compareFn(a, b) {
          if (a.event.start_at > b.event.start_at) {
            return -1;
          } else if (a.event.start_at < b.event.start_at) {
            return 1;
          }
          return 0;
        }

        this.user_participations =
          !response || response.length == 0 ? [] : response.sort(compareFn);
      });
  },
  methods: {
    state(res) {
      if (res.event.type_of_event === "crew_meeting") {
        return this.$t(
          "events.participations.status.crew_meeting." + res.status
        );
      }
      return this.$t("events.participations.status." + res.status);
    },
    translateType(event) {
      return this.$t("events.eventtypes." + event.type_of_event + ".title");
    },
    timePeriod(time_start, time_end) {
      let dateStart = new Date(time_start * 1000);
      let dateEnd = new Date(time_end * 1000);

      if (dateStart.toDateString() === dateEnd.toDateString()) {
        const hh = String(dateEnd.getHours()).padStart(2, "0");
        const mm = String(dateEnd.getMinutes()).padStart(2, "0");
        return `${this.datetime(time_start)} - ${hh}:${mm}`;
      }

      return this.datetime(time_start) + " - " + this.datetime(time_end);
    },
    userApplications() {
      return this.user_participations;
    },
  },
  computed: {
    current: {
      get() {
        return this.$store.state.users.current;
      },
      set(value) {
        this.$store.commit("users/current", value);
      },
    },
    ...mapGetters({
      hasPoolPermission: "user/roles/hasPoolPermission",
      hasSystemPermission: "user/roles/hasSystemPermission",
    }),
  },
};
</script>
